import { AppContext } from "@components/features/appContext/AppContext";
import Layout from "@components/primitives/layout/Layout";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import PrivacyNL from "./components/PrivacyNL";
import PrivacyEN from "./components/PrivacyEN";

function PrivacyPage() {
  const { language } = useContext(AppContext);

  return (
    <Layout>
      <Helmet>
        <title>{createTitle(translation(language).header.home)}</title>
      </Helmet>
      <div className="h-max bg-primary w-full pt-32 pb-20 px-5">
        {language === "nl_NL" && <PrivacyNL />}
        {language === "en_US" && <PrivacyEN />}
      </div>
    </Layout>
  );
}

export default PrivacyPage;
